/* eslint-disable max-len */
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';
import { viewport } from '../viewport';
import Lazyload from 'vanilla-lazyload';

function init(container = document) {
    const wrapper = container.querySelector('.js-vegetables');

    if (!wrapper) {
        return;
    }
    const lazyImages = wrapper.querySelectorAll('.lazy');

    ScrollTrigger.matchMedia({
        '(min-width: 1024px)': function () {
            wrapper.dataset.calcScrollTop = wrapper?.offsetTop;

            ScrollTrigger.create({
                trigger: '.js-vegetables',
                start: 'top top',
                end: () => `+=${viewport.height * 2.5}`,
                onEnter: () => {
                    lazyImages.forEach((image) => {
                        Lazyload.load(image);
                    });
                },
            });

            const sections = Array.from(wrapper.querySelectorAll('.vegetable'));
            let currentSection = sections[0];
            let curSectionWrapper = currentSection.closest('.js-vegetable-wrapper');
            sections.forEach((section, i) => {
                const trigger = document.getElementById(section.dataset.trigger);
                const sectionOffsetTop = wrapper?.offsetTop + trigger?.offsetTop;
                const img = section.querySelector('.vegetable__img');
                const content = section.querySelector('.vegetable__content');
                ScrollTrigger.create({
                    trigger,
                    start: 'top top',
                    end: () => `+=${viewport.height}`,
                    toggleActions: 'play pause reverse pause',
                    onToggle: (self) => {
                        self.isActive && setSection(section, self.direction);
                    },
                    onUpdate: ({ progress }) => {
                        gsap.timeline({ defaults: { duration: 0, ease: 'linear' } }).to(content, {
                            y: (1 - progress) * -50,
                        });
                    },
                });
            });

            function setSection(newSection, direction) {
                if (newSection !== currentSection) {
                    const newSectionWrapper = newSection.closest('.js-vegetable-wrapper');
                    newSectionWrapper.style.zIndex = 6;
                    currentSection.style.zIndex = '';
                    if (direction === 1) {
                        gsap.to(currentSection, { y: '100%' });
                        gsap.to(curSectionWrapper, { y: '-100%' });
                        gsap.fromTo(newSection, { y: '-100%' }, { y: '0%' });
                        gsap.fromTo(newSectionWrapper, { y: '100%' }, { y: '0%' });
                    } else {
                        gsap.to(currentSection, { y: '-100%' });
                        gsap.to(curSectionWrapper, { y: '100%' });
                        gsap.fromTo(newSection, { y: '100%' }, { y: '0%' });
                        gsap.fromTo(newSectionWrapper, { y: '-100%' }, { y: '0%' });
                    }
                    currentSection = newSection;
                    curSectionWrapper = newSectionWrapper;
                }
            }
        },
    });
}

const _module = { init };

export default _module;
